import { CSSProperties } from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';

const checkIcon = new URL('../../../img/check-circle-blue.svg', import.meta.url).href;

export interface OptionCard {
  value: string | number;
  label: string;
}

interface OptionCardsProps {
  options: OptionCard[];
  /** Массив — мультивыбор, скаляр — одиночный выбор */
  value: Array<string | number> | string | number | null;
  onChange: (value: string | number) => void;
  /** Количество колонок на десктопе; на мобиле всегда одна */
  columns?: number;
  className?: string;
}

/**
 * Сетка карточек-опций из макета: выбранная получает синюю рамку
 * и круглую галочку в правом верхнем углу.
 */
const OptionCards = ({ options, value, onChange, columns = 5, className }: OptionCardsProps) => {
  const selected = Array.isArray(value) ? value : [value];
  const isSelected = (option: OptionCard) =>
    selected.some((item) => item !== null && item !== undefined && String(item) === String(option.value));

  return (
    <div
      className={cn(styles.grid, className)}
      style={{ '--option-cards-columns': columns } as CSSProperties}
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={isSelected(option)}
          className={cn(styles.card, { [styles.cardSelected]: isSelected(option) })}
          onClick={() => onChange(option.value)}
        >
          {isSelected(option) && <img className={styles.check} src={checkIcon} alt="" />}
          <span className={styles.cardLabel}>{option.label}</span>
        </button>
      ))}
    </div>
  );
};

export default OptionCards;
